const GADS_ID = "AW-17489509584";

// Paste the Google Ads phone-call conversion label here when created
// (Google Ads → Goals → Conversions → new "Phone calls" action → label after the slash in send_to).
export const CALL_CONVERSION_LABEL = "ayE1COyV3e4cEND50pNB";

export function trackCall(source = "site") {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", "phone_call_click", {
    event_category: "engagement",
    event_label: source,
    send_to: GADS_ID,
  });
  if (CALL_CONVERSION_LABEL) {
    window.gtag("event", "conversion", {
      send_to: `${GADS_ID}/${CALL_CONVERSION_LABEL}`,
      value: 1.0,
      currency: "AUD",
    });
  }
}

// Google Ads "Request a booking" conversion with Enhanced Conversions user data
export function fireBookingConversion(form) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  const digits = (form.customer_phone || "").replace(/\D/g, "");
  const e164Phone = digits.length === 10 && digits.startsWith("0") ? `+61${digits.slice(1)}` : digits ? `+${digits}` : "";
  const userData = { email: (form.customer_email || "").trim().toLowerCase() };
  if (e164Phone) userData.phone_number = e164Phone;
  const nameParts = (form.customer_name || "").trim().split(/\s+/);
  if (nameParts[0]) {
    userData.address = {
      first_name: nameParts[0],
      last_name: nameParts.slice(1).join(" ") || nameParts[0],
      country: "AU",
    };
  }
  window.gtag("set", "user_data", userData);
  window.gtag("event", "conversion", {
    send_to: `${GADS_ID}/vOUACPqPpZkcEND50pNB`,
    value: 1.0,
    currency: "AUD",
    event_label: form.service,
  });
  window.gtag("event", "booking_submitted", {
    service: form.service,
    vehicle: `${form.vehicle_make} ${form.vehicle_model}`,
  });
}
